import { Alert as AlertImport, ButtonLink } from '@designsforhealth/dfh-react-components'
import styled, { css } from 'styled-components'

import CartItemQuantityControlImport from '../../../cart/CartItemQuantityControl'
import OptionalProductLinkImport from '../../../OptionalProductLink'
import ItemImage from '../ItemImage'

export const ItemForm = styled.form`
  width: 100%;
`

export const ItemHeader = styled.header`
  display: flex;

  &,
  h4 {
    line-height: 1.25;
    font-weight: 500;
  }
`

export const PriceBreakdown = styled.span`
  font-size: 0.75rem;
`

export const Total = styled.span`
  font-size: 0.875rem;
`

export const Price = styled.div<{ $productLabelStatus: boolean }>`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  flex-basis: 0;
  margin-left: auto;
  margin-bottom: auto;
  white-space: nowrap;

  & > span {
    font-size: 18px;
    font-family: Gotham, 'sans-serif';
    color: ${({ theme }) => theme.colors.blackPearlBlue.shade700};
  }

  ${({ $productLabelStatus }) =>
    $productLabelStatus === false &&
    css`
      @media (min-width: 600px) {
        flex-direction: row;
        align-items: flex-start;
        margin-bottom: unset;
      }
    `}
`

export const RetailPrice = styled.p`
  font-size: 12px;
  margin: 2px 0;
  color: ${({ theme }) => theme.colors.grayscale.gray40};
  @media (min-width: 600px) {
    margin: 4px 5px;
  }
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`

export const QuantityAndRemoveButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RemoveLink = styled(ButtonLink)`
  align-self: self-end;
  padding-right: 3px;
  color: #52616b;
  margin-bottom: 0;
  line-height: 2;
  transition: color 0.15s;

  &:hover {
    color: ${({ theme }) => theme.colors.component.link};
  }
`

export const OptionalProductLink = styled(OptionalProductLinkImport)`
  color: ${({ theme }) => theme.colors.blackPearlBlue.shade700};
  font-size: 18px;
  font-family: Gotham, 'sans-serif';
  text-decoration: none;
  transition: color 0.15s;

  h4 {
    margin-block-start: 0;
    margin-bottom: 5px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.component.link};
  }
`

export const CartItemQuantityControl = styled(CartItemQuantityControlImport)`
  .react-select__control {
    height: 35px;
  }
`

export const SizeTag = styled.div`
  display: flex;
  width: fit-content;
  font-family: Roboto, sans-serif;
  margin: 0 0 10px;
  padding: 3px 7px;
  white-space: nowrap;
  font-size: 8px;
  color: ${({ theme }) => theme.colors.brand.blue};
  font-weight: 400;
  border: 1px solid ${({ theme }) => theme.colors.brand.blue};
  border-radius: 50px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
`

export const FlavorTag = styled.div`
  font-family: Roboto, sans-serif;
  margin: 0 0 5px;
  white-space: nowrap;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.darkPurple.shade700};
  font-weight: 400;
`

export const DosageTag = styled.div`
  font-family: Roboto, sans-serif;
  margin: 0 0 5px;
  white-space: nowrap;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 400;
`

export const Alert = styled(AlertImport)`
  word-break: break-word;
`

export const CartItemComponent = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
  display: flex;
  padding: 20px 15px;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  ${ItemImage} {
    flex: 0 0 70px;
    height: 70px;
    margin-right: 10px;
  }
`
